import Input from './Input'

const Email = ({dense = true, ...props}) => (
  <Input
    {...props}
    label='Email'
    name='email'
    options={{
      required: 'Email is required',
      pattern: {
        value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
        message: 'Email is invalid'
      }
    }}
    margin={dense ? 'dense' : ''}
  />
)

export default Email
